import { render, staticRenderFns } from "./TimeDisplay.vue?vue&type=template&id=ab47dd9c&"
import script from "./TimeDisplay.vue?vue&type=script&lang=js&"
export * from "./TimeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports